import React, { Component, Fragment, useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Container from 'react-bootstrap/Container'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Buttons from '../Ui/buttons/Buttons'
import * as actions from '../../store/actions/index'

import Stepper from '@material-ui/core/Stepper'
import Step from '@material-ui/core/Step'
import StepButton from '@material-ui/core/StepButton'
import Shipping from './Shipping/Shipping'
import Payment from './Payment/Payment'
import './Checkout.css'

const Checkout = (props) => {

    const [steps, setSteps] = useState(
        [{
            name: "Shipping",
            component: <Shipping />
        },
        {
            name: "Payment",
            component: <Payment />
        },
        {
            name: "Done",
            component: <Payment />
        }]
    )

    const [currentStep, setCurrentStep] = useState(0)
    const dispatch = useDispatch()
    const subTotal = useSelector(state => state.product.subTotal)
    const totalQty = useSelector(state => state.product.totalQty)
    const totalPrice = useSelector(state => state.product.totalPrice)

    const isAuthenticated = useSelector(state => state.auth.token !== null)
    const onTryAutoSignup = () => dispatch(actions.authCheckState())
    const onSetAuthRedirectPath = path => dispatch(actions.setAuthRedirectPath(path))

    useEffect(() => {
        onTryAutoSignup()
    }, [onTryAutoSignup])


    if (!isAuthenticated || isAuthenticated == null) {
        onSetAuthRedirectPath('/checkout');
        props.history.push('/login');
    }


    return (
        <Container>
            <Stepper
                activeStep={currentStep}
                alternativeLabel>
                {steps.map((label, index) => (
                    <Step key={label.name}>
                        <StepButton onClick={() => {
                            setCurrentStep(index)
                        }}>
                            {label.name}
                        </StepButton>
                    </Step>
                ))}
            </Stepper>
            <Row>
                <Col md={8}>
                    {
                        steps[currentStep].component
                    }
                </Col>
                <Col md={4} className="gray-bg p-4">
                    <h3>Summary</h3>
                    <Row>
                        <Col md={4}>
                            Item(s)
                       </Col>
                        <Col md={4}>
                            <span className="sub-info">{totalQty}</span>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4}>
                            Subtotal
                       </Col>
                        <Col md={4}>
                            ${subTotal}
                        </Col>
                    </Row>
                    <Row className="border-top border-bottom mt-4 pt-3 pb-3 mt-3">
                        <Col md={4}>
                            <p className="sub-info">Total</p>
                        </Col>
                        <Col md={8}>
                            <p className="sub-info">${totalPrice}</p>
                        </Col>
                    </Row>

                </Col>
            </Row>

            <Row>
                <Col md={4}>
                    <Buttons
                        buttonType="primary"
                        // buttonAction={()=>handleAddtoCart(product)}
                        buttontext="Continue and Pay"
                        classInput="col-md-12 mt-4"
                    //  disabled={!formIsValid}
                    />
                </Col>
            </Row>
        </Container>
    )

}
export default Checkout